module.exports = __webpack_public_path__ + "img/general2.65fc31c6.jpg";